/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type DeactivateRegistryEntryResponse = {
  id: string;
  deactivated: boolean;
};

/** @internal */
export const DeactivateRegistryEntryResponse$inboundSchema: z.ZodType<
  DeactivateRegistryEntryResponse,
  z.ZodTypeDef,
  unknown
> = z.object({
  id: z.string(),
  deactivated: z.boolean(),
});
/** @internal */
export type DeactivateRegistryEntryResponse$Outbound = {
  id: string;
  deactivated: boolean;
};

/** @internal */
export const DeactivateRegistryEntryResponse$outboundSchema: z.ZodType<
  DeactivateRegistryEntryResponse$Outbound,
  z.ZodTypeDef,
  DeactivateRegistryEntryResponse
> = z.object({
  id: z.string(),
  deactivated: z.boolean(),
});

export function deactivateRegistryEntryResponseToJSON(
  deactivateRegistryEntryResponse: DeactivateRegistryEntryResponse,
): string {
  return JSON.stringify(
    DeactivateRegistryEntryResponse$outboundSchema.parse(
      deactivateRegistryEntryResponse,
    ),
  );
}
export function deactivateRegistryEntryResponseFromJSON(
  jsonString: string,
): SafeParseResult<DeactivateRegistryEntryResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => DeactivateRegistryEntryResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DeactivateRegistryEntryResponse' from JSON`,
  );
}
